import React from 'react';
import { ZoomIn, ZoomOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TreeControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export function TreeControls({ onZoomIn, onZoomOut }: TreeControlsProps) {
  return (
    <div className="absolute top-4 left-4 flex flex-col space-y-2 z-10">
      <Button
        variant="secondary"
        size="icon"
        onClick={onZoomIn}
        className="rounded-full"
        title="تكبير"
      >
        <ZoomIn className="w-5 h-5" />
      </Button>
      <Button
        variant="secondary"
        size="icon"
        onClick={onZoomOut}
        className="rounded-full"
        title="تصغير"
      >
        <ZoomOut className="w-5 h-5" />
      </Button>
    </div>
  );
}